<div class="grid h-12 grid-cols-[3rem_5rem_1fr]">
    <div></div>

    <div class="flex items-center justify-center">
        <mat-icon class="text-[#838383] dark:text-contrast-yellow">schedule</mat-icon>
    </div>

    <div class="mb-2 mt-2 flex items-center">
        <p class="ml-1 flex items-center text-xxs font-medium text-[#414141] dark:text-contrast-yellow">
            {{ 'ITINERARY_INSTRUCTIONS_WAIT_FOR' | translate }} {{ leg.duration | duration }}
        </p>
    </div>
</div>
